var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.814027 8.66669H0.813477V23.3334C0.813477 25.3584 2.4551 27 4.48014 27H27.519C29.5441 27 31.1857 25.3584 31.1857 23.3334V8.66712L0.814027 8.66669Z",
    fill: "#FFB357"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3723 13.5196C19.9475 12.0948 18.015 11.2943 15.9999 11.2943C13.9849 11.2943 12.0525 12.0948 10.6276 13.5196L0.813477 23.3333C0.813477 25.3584 2.4551 27 4.48014 27H27.519C29.5441 27 31.1857 25.3584 31.1857 23.3333L21.3723 13.5196Z",
    fill: "#FFCE71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91625 23.3333V18.2308H0.813477V23.3333C0.813477 25.3583 2.4551 27 4.48014 27H9.58292C7.55788 27 5.91625 25.3583 5.91625 23.3333Z",
    fill: "#FFB357"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5186 5H4.48014C2.4551 5 0.813477 6.64163 0.813477 8.66667L10.6274 18.4807C12.0522 19.9055 13.9847 20.706 15.9998 20.706C18.0148 20.706 19.9472 19.9055 21.3721 18.4807L31.1857 8.66667C31.1857 6.64138 29.5439 5 27.5186 5Z",
    fill: "#FCE3A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91625 13.7692V8.66667C5.91625 6.64163 7.55788 5 9.58292 5H4.48014C2.4551 5 0.813477 6.64163 0.813477 8.66667L5.91601 13.7692H5.91625Z",
    fill: "#FFCE71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.5554c0277ce74a2dd4c4c9e3dfe4a7a5.svg";
export { ForwardRef as ReactComponent };